const envs = [
  'production',
  'sandbox',
  'staging1',
  'staging2',
  'staging3',
  'staging4',
  'staging5',
  'staging6',
  'staging7',
  'staging8',
  'staging9',
  'staging10',
];

const getEnv = () => {
  const { host } = window.location;
  if (host === 'app.guestyforhosts.com') {
    return 'production';
  }
  // 'testapp' is an alternate staging URL hosted on an S3 bucket in the YPA AWS account.
  if (host === 'testapp.guestyforhosts.com') {
    return 'staging1';
  }
  const match = host.match(/app-(\w+)\.guestyforhosts\.com/);
  if (match && match[1] && envs.includes(match[1])) {
    return match[1];
  }
  return process.env.REACT_APP_CLUSTER || 'staging1';
};

const env = getEnv();

export default env;
